import React, { useState, useEffect } from 'react';
import { PDFDocument } from 'pdf-lib';
import Swal from 'sweetalert2'
import añadirDocumento from "../functions/añadirDocumento";
import { getAuth } from "firebase/auth";
import firebaseApp from "../firebase/credenciales";
import { serverTimestamp } from 'firebase/firestore';

function FDocumentos({usuario}) {
  const ruc = usuario.ruc;
  const [pdfFile, setPdfFile] = useState(null);
  const [firmaFile, setFirmaFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pdfWithFirma, setPdfWithFirma] = useState(null);
  const [adjustX, setAdjustX] = useState(0);
  const [adjustY, setAdjustY] = useState(0);
  const [titulo, setTitulo] = useState('');
  const auth = getAuth(firebaseApp);
  const currentUser = auth.currentUser;
  const autor = currentUser.email;
  const baseDatos = "plantillaDocumentos";

  useEffect(() => {
    if (pdfWithFirma) {
      URL.revokeObjectURL(pdfWithFirma);
    }
  }, [pdfWithFirma]);

  useEffect(() => {
    if (pdfFile && firmaFile) {
      incrustarFirmaEnPDF();
    }
  }, [adjustX, adjustY]);

  const handlePdfChange = (event) => {
    const file = event.target.files[0];
    setPdfFile(file);
  };

  const handleFirmaChange = (event) => {
    const file = event.target.files[0];
    setFirmaFile(file);
  };

  const handleAdjustXChange = (event) => {
    const value = Number(event.target.value);
    setAdjustX(value);
  };

  const handleAdjustYChange = (event) => {
    const value = Number(event.target.value);
    setAdjustY(value);
  };

  const handleTituloChange = (event) => {
    setTitulo(event.target.value);
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();

    if (!pdfFile || !firmaFile) {
      alert('Por favor, seleccione un archivo PDF y una imagen de firma');
      return;
    }

    setLoading(true);
    incrustarFirmaEnPDF();
    setLoading(false);
  };

  const incrustarFirmaEnPDF = async () => {
    const pdfData = await readFileAsync(pdfFile);
    const firmaData = await readFileAsync(firmaFile);

    const pdfDoc = await PDFDocument.load(pdfData);
    const firmaImage = await pdfDoc.embedPng(firmaData);

    const pages = pdfDoc.getPages();
    for (const page of pages) {
      const { width, height } = page.getSize();

      const firmaWidth = 100;
      const firmaHeight = 40;
      const xPos = width - firmaWidth - 150 + adjustX;
      const yPos = 80 + adjustY;

      page.drawImage(firmaImage, {
        x: xPos,
        y: yPos,
        width: firmaWidth,
        height: firmaHeight,
      });
    }

    const pdfBytes = await pdfDoc.save();
    const pdfWithFirmaData = new Blob([pdfBytes], { type: 'application/pdf' });
    setPdfWithFirma(pdfWithFirmaData);
  };

  const readFileAsync = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });
  };

  async function guardarRegistro() {
    //obtener los inputs
    //let documentoPDF = document.getElementById('pdfFile').value;
    //let firma = document.getElementById('firmaFile').value;
    let ajusteX = document.getElementById('adjustX').value;
    let ajusteY = document.getElementById('adjustY').value;
    let nombre = document.getElementById('titulo').value;
    let fechaDoc = serverTimestamp();
    let activo = true;
    let codigo = "PDF-FIRMA"
    let documento = "Plantilla de Firma";
    let tipo = "Boletas";


    //obtener la fecha del servidor de firebase


    //guardar en la base de datos utilizando la funcion añadirDocumento
    const infoDocumento = {
      documento,
      codigo,
      activo,
      ajusteX,
      ajusteY,
      nombre,
      fechaDoc,
      ruc,
      tipo,
    };

    const uid = await añadirDocumento(infoDocumento, autor, baseDatos, "Plantilla de Firma");

    //verificar si se genero el identificador de firebase de 20 caracteres
    if (uid.length === 20) {
      Swal.fire({
        icon: 'success',
        title: 'Plantilla guardada',
        text: 'El documento se guardó correctamente',
      });
      };
    }

  return (
    <div style={{ display: 'flex' }}>
      <div style={{ flex: '1', padding: '20px' }}>
        <h2>Incrustar firma en PDF</h2>

        <form onSubmit={handleFormSubmit}>
          <div>
            <label htmlFor="pdfFile">Archivo PDF:</label>
            <input type="file" id="pdfFile" accept=".pdf" onChange={handlePdfChange} />
          </div>

          <div>
            <label htmlFor="firmaFile">Imagen de firma (PNG):</label>
            <input type="file" id="firmaFile" accept=".png" onChange={handleFirmaChange} />
          </div>

          <div>
            <label htmlFor="adjustX">Ajuste en X:</label>
            <input type="number" id="adjustX" value={adjustX} onChange={handleAdjustXChange} />
          </div>

          <div>
            <label htmlFor="adjustY">Ajuste en Y:</label>
            <input type="number" id="adjustY" value={adjustY} onChange={handleAdjustYChange} />
          </div>
          <div>
            <label htmlFor="titulo">Título del documento:</label>
            <input type="text" id="titulo" value={titulo} onChange={handleTituloChange} />
          </div>
          

          <button type="submit" disabled={loading} style={{ backgroundColor: 'blue', color: 'white', padding: '10px 20px', margin: '10px 0' }}>
          {loading ? 'Procesando...' : 'Insertar Firma'}
        </button>
      </form>

      <button onClick={guardarRegistro} style={{ backgroundColor: 'green', color: 'white', padding: '10px 20px', margin: '0 0 10px 0' }}>
        Guardar Plantilla
      </button>
      </div>

      <div style={{ flex: '1', padding: '20px' }}>
        {pdfWithFirma && (
          <div>
            <h2>Documento Firmado</h2>
            <iframe src={URL.createObjectURL(pdfWithFirma)} width="100%" height="600px" title="PDF con Firma" />
          </div>
        )}
      </div>
    </div>
  );
}

export default FDocumentos;